interface Props {
  codes: string[];
  onSave: () => void;
  isLoading?: boolean;
}

export function HologramPreview({ codes, onSave, isLoading }: Props) {
  if (codes.length === 0) return null;

  return (
    <div className="space-y-4">
      <div className="border rounded-lg p-4 max-h-60 overflow-y-auto">
        <h3 className="font-semibold mb-2">Preview ({codes.length} codes)</h3>
        <div className="space-y-1">
          {codes.map((code, index) => (
            <div key={index} className="text-sm font-mono bg-muted p-1 rounded">
              {code}
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-end">
        <Button onClick={onSave} disabled={isLoading}>
          {isLoading ? "Saving..." : "Save Holograms"}
        </Button>
      </div>
    </div>
  );
}

import { Button } from "@/components/ui/button";